// Activate images only after the cover is opened, and only near the viewport.
export function activatePhotos(): void {
  const load = (picture: HTMLPictureElement) => {
    picture.querySelectorAll<HTMLElement>("[data-srcset], [data-src]").forEach((element) => {
      if (element.dataset.srcset) { element.setAttribute("srcset", element.dataset.srcset); delete element.dataset.srcset; }
      if (element.dataset.src) { element.setAttribute("src", element.dataset.src); delete element.dataset.src; }
    });
  };
  if (!("IntersectionObserver" in window)) {
    document.querySelectorAll<HTMLPictureElement>("picture").forEach(load);
    return;
  }
  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) if (entry.isIntersecting) {
      load(entry.target as HTMLPictureElement); observer.unobserve(entry.target);
    }
  }, { rootMargin: "180px" });
  document.querySelectorAll<HTMLPictureElement>("picture").forEach((picture) => observer.observe(picture));
}
